import { CustomTabs } from './custom-tabs';
import { CvParsingLoadingState } from './cv-parsing-loading-state';
export var Tabs = CustomTabs;
export { CvParsingLoadingState };